var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsTwDelivery = function SvgNnIconFlagsTwDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-TW-delivery_svg__Lager_42",
    "data-name": "Lager 42",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-TW-delivery_svg__cls-4{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h24.98v16.66H.25z",
    style: {
      fill: "#0000c2"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.86 3.17-2 2.05a3.5 3.5 0 0 1 1.29.74ZM16.23 9.33l2.78-.75-2.78-.74a3.7 3.7 0 0 1 .08.74 3.7 3.7 0 0 1-.08.75M13.48 5.12l-.74-2.78L12 5.12a3.5 3.5 0 0 1 .74-.08 3.7 3.7 0 0 1 .74.08M18.15 11.71l-2-2a3.6 3.6 0 0 1-.79 1.2ZM9.62 3.17l.75 2.79a3.6 3.6 0 0 1 1.28-.75ZM9.62 13.99l2-2a3.4 3.4 0 0 1-1.28-.75ZM7.33 5.46l2 2a3.5 3.5 0 0 1 .75-1.29ZM15.86 13.99l-.75-2.79a3.5 3.5 0 0 1-1.29.75ZM7.33 11.71l2.79-.8a3.4 3.4 0 0 1-.75-1.28ZM18.15 5.46l-2.79.75a3.6 3.6 0 0 1 .75 1.29ZM9.28 7.84l-2.79.74 2.79.75a3.7 3.7 0 0 1-.08-.75 3.7 3.7 0 0 1 .08-.74M12 12.04l.74 2.79.74-2.79a3.7 3.7 0 0 1-.74.08 3.5 3.5 0 0 1-.74-.08",
    className: "nn-icon-flags-TW-delivery_svg__cls-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.74 5.46a3.13 3.13 0 1 1-3.12 3.12 3.12 3.12 0 0 1 3.12-3.12",
    className: "nn-icon-flags-TW-delivery_svg__cls-4"
  })));
};
export default SvgNnIconFlagsTwDelivery;